import React from 'react';

import classNames from 'classnames';

import { formatFigure } from 'Helpers/formatService';

/**
 * IB-757 — Budget Versions v2 (compare polish).
 *
 * The "shape of budget" cluster for a version row: departments, cost centres and
 * total workforce, each on its own row — label on the left, value on the right
 * with a small signed delta versus the comparison reference (green when the
 * count rose, red when it fell). `deltas` re-bases with the Compare dropdown, so
 * the whole row stays consistent with the money cells.
 */
function ShapeRow({ label, value, delta }) {
    const hasDelta = typeof delta === 'number' && delta !== 0;
    const sign = delta > 0 ? '+' : '';

    return (
        <div className="tw-flex tw-items-baseline tw-justify-between tw-gap-x-3">
            <span className="tw-text-xs tw-text-charcoal-50">{label}</span>
            <span className="tw-text-sm tw-font-medium tw-text-charcoal">
                {formatFigure(value, String)}
                {hasDelta && (
                    <span
                        className={classNames('tw-ms-1.5 tw-text-2xs tw-font-semibold', delta > 0 ? 'tw-text-green' : 'tw-text-red')}
                    >{`${sign}${delta}`}</span>
                )}
            </span>
        </div>
    );
}

export default function ShapeCluster({ metrics, deltas = {} }) {
    if (!metrics) {
        return <td />;
    }

    return (
        <td className="tw-align-middle">
            <div className="tw-flex tw-flex-col tw-gap-y-1 tw-min-w-[140px]">
                <ShapeRow label={$t('Departments')} value={metrics.departments_count} delta={deltas.departments_count} />
                <ShapeRow label={$t('Cost centres')} value={metrics.costcenters_count} delta={deltas.costcenters_count} />
                <ShapeRow label={$t('Workforce')} value={metrics.workforce_count} delta={deltas.workforce_count} />
            </div>
        </td>
    );
}
